module.exports = __webpack_public_path__ + "img/logo.4abe41d4.png";